export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const MOBILE_TOGGLE_SIDEBAR = 'MOBILE_TOGGLE_SIDEBAR';
export const CHAT_BOT = 'CHAT_BOT';
